import { Draggable } from 'react-beautiful-dnd';
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const DraggableLocation = ({
  location,
  index,
  canModifyLocations,
  onLocationClick,
}) => (
  <Draggable key={location.id} draggableId={location.id} index={index} isDragDisabled={!canModifyLocations}>
    {provided => (
      <div
        className="u-mt--"
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onClick={canModifyLocations ? onLocationClick : noop}
        disabled={!canModifyLocations}
      >
        {location.name}
      </div>
    )}
  </Draggable>
);

DraggableLocation.propTypes = {
  location: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  canModifyLocations: PropTypes.bool.isRequired,
  onLocationClick: PropTypes.func.isRequired,
};

export default DraggableLocation;
